module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"processed.waiting":"รอประมวลผล","processed.error":"ไม่สามารถตรวจสอบ Log ได้","processed.done":"ดู Log"}}')
  delete Component.options._Ctor
}
